module.exports = __webpack_public_path__ + "bg-1-emea.jpg";